<template>
    <div class="lc_topBarWeb TQ_verticalAlignMiddle TQ_bg_white" >

        <div class="logo TQ_direction_ltr"  >

            <!-- logo/backBtn-->
            <div class="TQ_verticalAlignTop TQ_inline">
                <tq-image v-if="p_showBackBtn_b" :src="ass_img_arrowHeadLeft_p" class="TQ_width_40px TQ_clickable " @click.native="m_clickBackBtn_f"/>
                <tq-link v-else :p_link_s="enum_moveToOptions.player_play">
                    <logo  width="60px" class="TQ_clickable"/>
                </tq-link>
            </div>

            <!-- space -->
            <div class="TQ_inline TQ_padding_4px"></div>

            <!-- clock-->
            <div class="TQ_inline TQ_border_p TQ_textColor_purple TQ_borderRadius TQ_verticalAlignTop TQ_padding_2px TQ_text_28px TQ_margin_2px"
                 v-if="com_pathOngoingQuest_b">
                {{format_duration_hhmmss(p_millSecToEndQuest_n)}}

            </div>

            <!-- current points -->
            <div class="TQ_inline TQ_textColor_white TQ_borderRadius TQ_verticalAlignTop TQ_bg_purple TQ_padding_2px TQ_text_28px TQ_margin_2px"
                 v-if="com_pathOngoingQuest_b && p_currentScore_n != null">

                <div class="TQ_inline TQ_verticalAlignMiddle"> {{p_currentScore_n}} </div>
                <div class="TQ_padding_1px TQ_inline TQ_verticalAlignMiddle"> </div>
                <tq-image :pb_src_r="ass_img_oneStar_w" class="TQ_borderRadius TQ_verticalAlignMiddle TQ_width_24px"/>

            </div>
        </div>

        <div class="lc_tabs TQ_center ">

            <logo v-if="p_showBackBtn_b && pb_nabBarTabs_ac && pb_nabBarTabs_ac.length === 0 " width="64px" class="TQ_padding_8px "/>

            <router-link v-else
                         :to="route_addLangToPath_s(tab.path)"
                         v-for="(tab, index) in pb_nabBarTabs_ac"
                         :key="index"
                         class="lc_tab TQ_center TQ_borderBox TQ_textColor_gray12">

                <tq-beacon :p_show-beacon_b="tab.showBeacon_b && !m_sameRoute_fb(tab.path)" class="TQ_verticalAlignMiddle TQ_inline">
                    <div class="lc_name TQ_verticalAlignMiddle TQ_inline TQ_text_24px "
                         :class="m_sameRoute_fb(tab.path) ? 'TQ_textColor_purple TQ_text_bold TQ_animation_width' :  'TQ_animation_width_hover TQ_textColor_purple_lite_hover'">
                        <tq-notification-container :num="tab.notification_n" :show="tab.notification_n>0">
                            {{tab.name_byLangCode[ps_langCode_e]}}
                        </tq-notification-container>
                        <div class="TQ_animation_width_innerDive TQ_center"></div>
                    </div>
                </tq-beacon>
            </router-link>

        </div>

        <div class="right">
            <menu-drop-down
                :p_current-user-data_c="pb_currentUser_c"
                :p_system-lang-code_e="ps_langCode_e"
                :p_run-in_e="p_runIn_e"
                :p_current-currency_e="p_currentCurrency_e"
                :p_nav-bar_menu_ac="p_navBar_menu_ac"
                :pe_change-currency_f="pe_changeCurrency_f"
            />
        </div>

    </div>
</template>

<script>
    import Logo from "../../components/a_smartIcons/si_Logo";
    import {FB_UserData} from "../../../functions/src/shareCode/Share_S_Classes";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import FullLogo from "../../components/a_smartIcons/si_fullLogo";
    import {route_addLangToPath_s, route_back, route_currentPath_s, route_moveToRoute} from "../../router";
    import MenuDropDown from "./C_App_MenuDropDown";
    import {enum_moveToOptions, enum_runIn_es} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqImage from "../../components/basic/TqImage";
    import {ass_img_arrow_head_left_p, ass_img_oneStar_w} from "../../assets/scripts/Ass_Files";
    import TqOnTopContainer from "../../components/basic/TqOnTopContainer";
    import TqBeacon from "../../components/basic2/TqBeacon";
    import {format_duration_hhmmss} from "../../../functions/src/shareCode/Share_S_Format";
    import TqLink from "@/components/basic/TqLink";
    import TqNotificationContainer from "@/components/basic/TqNotificationContainer";
    export default {
        name: "TopBarWeb",
        components: {TqNotificationContainer, TqLink, TqBeacon, TqOnTopContainer, TqImage, MenuDropDown, FullLogo, Logo},
        props:{
            pb_currentUser_c : {
                require: true,
                type: FB_UserData
            },
            pb_nabBarTabs_ac:{
                Type: Array,
                require:true
            },
            p_navBar_menu_ac : {
                type: Array,
                require: true,
            },
            p_millSecToEndQuest_n:{
                type: Number,
                require : true,
            },
            p_currentScore_n:{
                type: Number,
                require : true,
            },

            // ======= system ========
            ps_langCode_e:{
                type: String,
                require: true
            },
            p_backTo_s:{
                type: String,
                require: true
            },

            // ======= flags ========
            p_showBackBtn_b:{
                Type: Boolean,
                require:true
            },
            p_runIn_e: {
                type: String,
                require: true,
                validator(val_e) {
                    return validator_enum_fb(enum_runIn_es, val_e)
                }
            },

            p_currentCurrency_e:{},
            pe_changeCurrency_f:{},
        },
        data() {
            return {
                ass_strings             : ass_strings,
                ass_img_arrowHeadLeft_p : ass_img_arrow_head_left_p,
                route_addLangToPath_s   : route_addLangToPath_s,
                format_duration_hhmmss  : format_duration_hhmmss,
                ass_img_oneStar_w  : ass_img_oneStar_w,
                enum_moveToOptions  : enum_moveToOptions,
            }
        },
        computed:{
            com_pathOngoingQuest_b(){
                return route_currentPath_s(this.$route).includes(enum_moveToOptions.ongoing)
            }
        },
        methods: {
            m_sameRoute_fb(route_s){

                switch(route_s){

                    case enum_moveToOptions.root:

                        let currentPath = route_currentPath_s(this.$route)

                        return currentPath === route_addLangToPath_s(enum_moveToOptions.root)
                            || currentPath + "/" === route_addLangToPath_s(enum_moveToOptions.root)
                            || currentPath.includes(route_addLangToPath_s(enum_moveToOptions.root_sub))

                    default:
                        return this.$route.path.includes(route_s)
                }


            },
            m_clickBackBtn_f(){
                if(this.p_backTo_s){
                    route_moveToRoute(this.p_backTo_s)
                }else{
                    route_back()
                }
            }
        },
    }
</script>

<style scoped lang="scss">

    .lc_topBarWeb{
        width: 100%;
        position: fixed;
        top: 0;

        .logo {
            display: inline-block;
            position: fixed;
            top: 10px;
            left: 10px;

            .status{
                margin-top: -10px;
                margin-right: -4px;
                /*font-family: Impact;*/
                font-weight: bold;
                color: #501078;
                color: var(--color-purple);

                text-transform: capitalize;
                /*font-family: 'comic sans ms regular';*/
            }
        }

        .lc_tabs{
            margin-left: 100px;
            margin-right: 100px;
            /*background: var(--color-gray4);*/

            .lc_tab{
                display: inline-block;
                padding: 11px;
                cursor: pointer;
                max-height: 78px;

                /*background: white;*/

                .lc_name {
                    display: inline-block;
                    margin: 0 8px;
                    //font-size: 24px;
                    /*font-family: 'comic sans ms regular';*/
                    text-transform: capitalize;
                    /*font-family: 'ganclm bold';*/
                    /*font-family: 'SuezOne Regular';*/
                    font-family: 'SecularOne Regular';
                }

                &.lc_selectedTab{
                    /*border-bottom: 4px solid var(--color-purple);*/
                    margin: 0px 2px;
                    color: white;
                    background: #501078;
                    background: var(--color-purple);

                }

                //&:hover {
                //    font-weight: bold;
                //    img {
                //        transform: scale(1.1);
                //    }
                //    /*.name{*/
                //        /*transform: scale(1.1);*/
                //    /*}*/
                //}
            }
        }

        .right{
            position: absolute;
            top: 0px;
            right: 0px;
        }


    }

</style>